import React from 'react';
import { PropTypes } from 'prop-types';

import { Icon } from '@ontruck/orc';

const RecurringOrderCard = ({
  className,
  schedule,
  locations,
  status,
  openOrder,
  isFirst,
}) => (
  <div
    className={`${className} ${isFirst ? 'first' : ''}`}
    onClick={openOrder}
    role="presentation"
  >
    <div className="recurrent-icon">
      <Icon glyph="recurring" size="24px" color="grey700" />
    </div>
    <div className="info">
      <p>{locations}</p>
      <p className="schedule">{schedule}</p>
    </div>
    <div className="status">{status}</div>
  </div>
);

RecurringOrderCard.propTypes = {
  className: PropTypes.string,
  schedule: PropTypes.string,
  locations: PropTypes.string,
  status: PropTypes.string,
  isFirst: PropTypes.bool,
  openOrder: PropTypes.func.isRequired,
};

RecurringOrderCard.defaultProps = {
  className: '',
  schedule: '',
  locations: '',
  status: '',
  isFirst: false,
};
export default RecurringOrderCard;
